/* eslint-disable react/prop-types */
import React from 'react';
import {
  CpdsBreadcrumbNav,
  CpdsBreadcrumbOl,
  CpdsBreadcrumbLi,
  CpdsBreadcrumbA,
  CpdsBreadcrumbSpan,
  CpdsBreadcrumbSVG,
} from './styles/cpds-breadcrumb-style';
import { CdpsBreadcrumbsProps, CdpsBreadcrumbsItemProps } from './types';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsBreadcrumbs: React.FC<CdpsBreadcrumbsProps> & { Item: React.FC<CdpsBreadcrumbsItemProps> } = ({
  crumbs,
  styleOverrides,
  ...rest
}) => {
  const { themeColorMode, themeTypography, exClasses } = rest;
  const className = themeStyleClass('cpds-breadcrumbs', themeTypography, exClasses);

  return (
    <CpdsBreadcrumbNav className={className} styleOverrides={styleOverrides} themeColorMode={themeColorMode}>
      <CpdsBreadcrumbOl className="cpds-breadcrumbs-wrapper">
        {crumbs.map((item, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <CpdsBreadcrumbLi className={`sub-item`} key={`${item}-${index}`} themeColorMode={themeColorMode}>
              {React.cloneElement(item, { themeColorMode, themeTypography })}
              {!isLast && (
                <CpdsBreadcrumbSVG
                  viewBox="0 0 6 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  themeColorMode={themeColorMode}
                >
                  <path
                    d="M1.66656 0L0.726562 0.94L3.7799 4L0.726562 7.06L1.66656 8L5.66656 4L1.66656 0Z"
                    fill="black"
                  />
                </CpdsBreadcrumbSVG>
              )}
            </CpdsBreadcrumbLi>
          );
        })}
      </CpdsBreadcrumbOl>
    </CpdsBreadcrumbNav>
  );
};

const CpdsBreadcrumbItem: React.FC<CdpsBreadcrumbsItemProps> = ({
  active,
  itemLink,
  itemCopy,
  itemTarget,
  clickstreamData,
  ...rest
}) => {
  const { themeColorMode, themeTypography } = rest;

  return active ? (
    <CpdsBreadcrumbSpan className={`${themeTypography}`} themeColorMode={themeColorMode}>
      {itemCopy}
    </CpdsBreadcrumbSpan>
  ) : (
    <CpdsBreadcrumbA
      className={`${themeTypography}`}
      href={itemLink}
      target={itemTarget}
      themeColorMode={themeColorMode}
      data-isclickstreamenabled = {true}
      data-clickstreamdata = {clickstreamData}
    >
      {itemCopy}
    </CpdsBreadcrumbA>
  );
};

CpdsBreadcrumbs.Item = CpdsBreadcrumbItem;

export { CpdsBreadcrumbs };
